<template>
  <tr>
    <th v-if="index === 0" :rowspan="recordCount">{{ title }}</th>
    <td  v-if="!onlyShowSelected" style="text-align: center;" :class="account.highlighted ? 'td-custom-highlight' : ''">
      <div class="custom-control custom-switch">
        <input type="checkbox" class="custom-control-input" v-model="account.selected" :id="account.id" @change="$emit('selectAccount', { selected: $event.target.checked, id: account.id })">
        <label class="custom-control-label" :for="account.id"></label>
      </div>
    </td>
    <td v-for="(column, columnIndex) in debitTableColumns" :key="columnIndex" :style="column.style" :class="account.highlighted ? 'td-custom-highlight' : ''">
      <template v-if="column.filter === 'currency'">{{ account[column.key] | currency }}</template>
      <template v-else>{{ account[column.key] }}</template>
    </td>
    <td v-for="(column, columnIndex) in creditTableColumns" :key="columnIndex" :style="`${column.style}${columnIndex === 0 ? 'border-left: 1px solid #dee2e6;' : ''}`" :class="account.highlighted ? isMinuend ? 'td-custom-highlight-minuend' : 'td-custom-highlight-subtrahend' : ''">
      <template v-if="column.filter === 'currency'">{{ account[column.key] | currency }}</template>
      <template v-else>{{ account[column.key] }}</template>
    </td>
  </tr>
</template>

<script>
import { currency } from "../../filters/Currency";

export default {
  emits: ["selectAccount"],
  filters: {
      currency
  },
  props: {
    recordCount: {
      required: true,
      type: Number
    },
    index: {
      required: true,
      type: Number
    },
    account: {
      required: true
    },
    creditTableColumns: {
      required: true
    },
    debitTableColumns: {
      required: true
    },
    title: {
      required: true,
      type: String
    },
    onlyShowSelected: {
      required: true,
      type: Boolean
    },
    isMinuend: {
      required: true,
      type: Boolean
    }
  }
}
</script>
